/**
 * Core Framework Dependencies
 */
import { Turbo } from "@hotwired/turbo-rails"
import jquery from 'jquery'

// Set up jQuery globally before importing Bootstrap
window.jQuery = jquery
window.$ = jquery

import '../lib/vendor_imports'
// import '../controllers/v1'
import "core-js/stable"
import "regenerator-runtime/runtime"
import 'https://kit.fontawesome.com/6b02558cc0.js'
import '../controllers/portal'
import './account_tweaks.scss'

/**
 * Application Modules
 */
import { navTabsManager, navTabsButtonManager } from '../lib/modules/nav_tabs.js'
import { initializeBundles } from '../lib/bundle_loader'
import VenueMap from '../bundles/maps/venue_map'
import AddressAutocomplete from '../bundles/maps/address_autocomplete'

/**
 * Dynamic Bundle Configuration
 */
const BUNDLE_MAP = {
    // '#tokbox_video': () => import('../bundles/tokbox_video/components/VideoApp.')
    //   .catch(error => console.error('Failed to load tokbox:', error))
};

    console.log('BUNDLE_MAP', BUNDLE_MAP);
/**
 * Application Initialization
 */
const initializeApplication = () => {
  console.log('Vite ⚡️ Rails - Public Event Application Loaded')


  // Initialize tab management
  navTabsManager()
  navTabsButtonManager()

  // Make venue-specific features globally available
  window.VenueMap = VenueMap
  window.AddressAutocomplete = AddressAutocomplete
  console.log('BUNDLE_MAP', BUNDLE_MAP);
  // Initialize dynamic bundles
//   initializeBundles(BUNDLE_MAP)
}

// Start application after Turbo navigation
document.addEventListener('turbo:load', initializeApplication)

// Initialize Turbo
Turbo.start()
